import { faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { UpdateOrganizationUserForm } from '~/components/forms/OrganizationUserForm';
import { RemoveOrganizationUserForm } from '~/components/forms/RemoveOrganizationUserForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';
import { parseUserInfo } from '~/helpers/parseUserInfo';
import { useOrganizationUserQuery } from '~/lib/api/modules/Organizations/hooks/useOrganizationUserQuery';

export type IOrganizationUserPageProps = {
  organizationId: string;
  userId: string;
};

export const OrganizationUserPage: React.FC<IOrganizationUserPageProps> = (
  props,
) => {
  const { organizationId, userId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const organizationUserQuery = useOrganizationUserQuery({
    organizationId,
    userId,
  });
  const organizationUserInfo = organizationUserQuery.data
    ? parseUserInfo(organizationUserQuery.data)
    : undefined;
  const organizationUserListUrl = `/organizations/${organizationId}/users`;

  return (
    <>
      <Helmet>
        <title>{t('common.organizationUser')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faUser} />}
        title={
          <QuerySkeleton
            query={organizationUserQuery}
            length={{ min: 8, max: 16 }}
          >
            {organizationUserInfo?.fullName}
          </QuerySkeleton>
        }
        previousUrl={organizationUserListUrl}
      />

      <UpdateOrganizationUserForm
        organizationId={organizationId}
        userId={userId}
        onSuccess={() => navigate(organizationUserListUrl)}
      />
      <RemoveOrganizationUserForm
        organizationId={organizationId}
        userId={userId}
        onSuccess={() => navigate(organizationUserListUrl)}
      />
    </>
  );
};
